import { render, staticRenderFns } from "./DetailIndustries.vue?vue&type=template&id=61274461&"
import script from "./DetailIndustries.vue?vue&type=script&lang=js&"
export * from "./DetailIndustries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports